// @flow
import type {UnmappedVisitorCategory, VisitorCategory} from "./type";

export const mapVisitorCategory: VisitorCategory = (datum: UnmappedVisitorCategory) => {
    if (!(datum && datum.length > 0)) return []
    return datum.map(d => ({
        id: d.id,
        textColor: d.Color1,
        backgroundColor: d.Color2,
        text: {
            en: d.DescriptionEN,
            el: d.DescriptionEL,
        },
        explanation: {
            en: d.ExplanationEN,
            el: d.ExplanationEL,
        },
        exhibitionDescription: {
            en: d.ExhibitionDescrEN,
            el: d.ExhibitionDescrEL,
        },
        exhibitionId: d.ExhibitionId,
        displayVisitorLabelInBadge: d.hasVisitorText === '1',
        showPreregistration: d.showPreregistration === '1',
        showOrganizer: d.showOrganizer === '1',
        badgeTemplateTypeId: d.BadgeTemplateTypeId,
    }))
}